(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-gallery"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__irandreProductSwipeHintInitialized) return;
    window.__irandreProductSwipeHintInitialized = true;

    const showHint = () => {
      if (window.matchMedia('(max-width: 749px)').matches === false) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      const galleries = [...document.querySelectorAll('#MainContent .card-gallery[data-swipe-hint]')].filter((gallery) => {
        const list = gallery.closest('.resource-list, .product-grid');
        return list && !list.classList.contains('resource-list__carousel');
      });
      if (galleries.length === 0) return;

      let hintShown = false;
      let observer;

      const getVisibleGallery = () =>
        galleries.find((gallery) => {
          const { top, bottom } = gallery.getBoundingClientRect();
          return top < window.innerHeight * 0.78 && bottom > window.innerHeight * 0.22;
        });

      const revealHint = (gallery) => {
        if (hintShown) return;

        hintShown = true;
        observer?.disconnect();
        gallery.classList.add('card-gallery--swipe-hint-visible');

        let dismissed = false;
        let dismissTimer;
        let removeHidingTimer;

        const dismissHint = () => {
          if (dismissed) return;
          dismissed = true;
          window.clearTimeout(dismissTimer);
          gallery.classList.remove('card-gallery--swipe-hint-visible');
          gallery.classList.add('card-gallery--swipe-hint-hiding');
          removeHidingTimer = window.setTimeout(() => {
            gallery.classList.remove('card-gallery--swipe-hint-hiding');
          }, 520);
        };
        dismissTimer = window.setTimeout(dismissHint, 3600);

        gallery.addEventListener('pointerdown', dismissHint, { once: true, passive: true });
        gallery.addEventListener('click', dismissHint, { once: true });
      };

      const findOrObserveVisibleGallery = () => {
        const visibleGallery = getVisibleGallery();
        if (visibleGallery) {
          revealHint(visibleGallery);
          return;
        }

        observer = new IntersectionObserver(
          (entries) => {
            const visibleEntry = entries.find((entry) => entry.isIntersecting);
            if (visibleEntry) revealHint(visibleEntry.target);
          },
          { threshold: 0.35 }
        );
        galleries.forEach((gallery) => observer.observe(gallery));
      };

      window.setTimeout(findOrObserveVisibleGallery, 4000);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', showHint, { once: true });
    } else {
      showHint();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["irandre-policy-page"] && !Shopify.designMode) return;
  try {
    function buildPolicyNavigation() {
    document.querySelectorAll('.ir-policy-document').forEach(documentRoot => {
      const toc = documentRoot.querySelector('.ir-service-toc');
      const policy = documentRoot.querySelector('.shopify-policy__body');
      if (!toc || !policy || toc.dataset.ready) return;
      const headings = [...policy.querySelectorAll('h2, h3, p > strong')].filter(node => {
        const text = node.textContent.trim();
        let previous = node.previousSibling;
        while (previous && previous.nodeType === Node.TEXT_NODE && !previous.textContent.trim()) previous = previous.previousSibling;
        const startsLine = node.tagName !== 'STRONG' || !previous || previous.nodeName === 'BR';
        return startsLine && text.length > 2 && text.length < 150 && !node.closest('a, li, table');
      });
      if (headings.length < 2) return;
      const nav = toc.querySelector('nav');
      headings.forEach((node, index) => {
        if (!node.id) node.id = `ir-policy-part-${index + 1}`;
        const link = document.createElement('a');
        link.href = `#${node.id}`;
        link.textContent = node.textContent.trim();
        nav.append(link);
      });
      toc.hidden = false;
      toc.dataset.ready = 'true';
      const title = documentRoot.querySelector('.shopify-policy__title');
      if (title) title.after(toc);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', buildPolicyNavigation, { once: true });
  else buildPolicyNavigation();
  document.addEventListener('shopify:section:load', buildPolicyNavigation);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-media-gallery-content"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__irandreSlideshowPillInitialized) return;
    window.__irandreSlideshowPillInitialized = true;

    const updateActivePill = (dots, selectedIndex = null) => {
      const buttons = [...dots.querySelectorAll('button')];
      const active = selectedIndex === null ? dots.querySelector("button[aria-selected='true']") : buttons[selectedIndex];
      if (!active) return;

      const dotsRect = dots.getBoundingClientRect();
      const activeRect = active.getBoundingClientRect();
      const x = activeRect.left - dotsRect.left + (activeRect.width - Math.min(activeRect.width - 2, 18)) / 2;
      const width = Math.min(activeRect.width - 2, 18);

      dots.style.setProperty('--active-pill-x', `${x}px`);
      dots.style.setProperty('--active-pill-width', `${width}px`);
      dots.style.setProperty('--active-pill-opacity', '1');
    };

    const bindDots = (dots) => {
      updateActivePill(dots);

      const slideshow = dots.closest('slideshow-component');
      slideshow?.addEventListener('slideshow:select', (event) => {
        const selectedIndex = event.detail?.index;
        if (typeof selectedIndex === 'number') {
          updateActivePill(dots, selectedIndex);
        }
      });

      window.addEventListener('resize', () => updateActivePill(dots), { passive: true });
    };

    const initialize = () => {
      document.querySelectorAll('.slideshow-controls__dots').forEach(bindDots);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialize, { once: true });
    } else {
      initialize();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
